import { defineMessages } from 'react-intl'

const messages = defineMessages({
  placeholder0: {
    id: 'RegionChangerController.placeholder0',
    description: 'Texto para el placeholder del componente para el cambio de region para la capa 0',
    defaultMessage: 'Seleccionar región'
  },
  placeholder1: {
    id: 'RegionChangerController.placeholder1',
    description: 'Texto para el placeholder del componente para el cambio de region para la capa 1',
    defaultMessage: 'Cambiar de región'
  }
})

export default messages



// WEBPACK FOOTER //
// ./src/modules/Controllers/RegionChanger/RegionChangerController/messages.js